import { AccountBindEmail } from '@bz/account';

export const route: RouteDefinition = {
  preload: () => {
    // return get.getMarketTypeList({sportType: Number(params.sportType)});
  },
  info: {
    dialog: {
      get title() {
        return t('Bind Email');
      },
      class: 'w-[500px] h-[700px]',
    },
  },
};

export default AccountBindEmail;
